// Reserved filename marker for the graduation ruler image field.
// An ImageField whose `.filename` equals this constant is rendered as
// a locked, non-selectable overlay (see FabricFieldHelper). Kept in
// domain/image so both the engine and the stores can compare against
// it without reaching into infrastructure.
const GRADUATION_NAME = 'GRADUATION';

export { GRADUATION_NAME };
